function t() {
  this.__data__ = [], this.size = 0;
}
export {
  t as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_listCacheClear.js
// module id = 1484
// module chunks = 41